import { newEventId } from "./track";

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];

// Persist UTM params on first landing so they survive through the whole funnel.
export function captureUtm() {
    try {
        const params = new URLSearchParams(window.location.search);
        const fresh = {};
        UTM_KEYS.forEach((k) => { const v = params.get(k); if (v) fresh[k] = v; });
        const stored = JSON.parse(localStorage.getItem("bh_utm") || "{}");
        const merged = Object.keys(fresh).length ? { ...stored, ...fresh } : stored;
        if (Object.keys(fresh).length) localStorage.setItem("bh_utm", JSON.stringify(merged));
        return merged;
    } catch { return {}; }
}

export function getUtm() {
    try { return JSON.parse(localStorage.getItem("bh_utm") || "{}"); } catch { return {}; }
}

export function bhajanVisitorId() {
    try {
        let v = localStorage.getItem("bh_vid");
        if (!v) { v = newEventId(); localStorage.setItem("bh_vid", v); }
        return v;
    } catch { return newEventId(); }
}
